// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__AyJV9","label":"styles_label__kudUX","icon":"styles_icon__3T9XZ"};